<header class="tasks-header">
  <button *ngIf="selectedTask; else title" type="button" class="br-btn br-btn--ghost br-btn--sm"
          (click)="selectedId = null" aria-label="Back to tasks">
    <br-icon aria-hidden="true">arrow_back</br-icon>Tasks
  </button>
  <ng-template #title><h2>Tasks</h2></ng-template>
  <button type="button" class="br-btn br-btn--ghost br-btn--sm tasks-return"
          (click)="returnToConversation.emit()">Back to conversation</button>
</header>

<div class="tasks-scroll" [hidden]="!!selectedTask" aria-label="Tasks in this conversation">
  <div *ngIf="!tasks.length" class="tasks-empty">
    <br-icon aria-hidden="true">checklist</br-icon>
    <p>No tasks yet</p>
    <span>Tasks for this conversation will appear here.</span>
  </div>
  <ng-container *ngFor="let group of [{ title: 'In progress', tasks: inProgress }, { title: 'Recent', tasks: recent }]">
    <ng-container *ngIf="group.tasks.length">
      <h3>{{ group.title }}</h3>
      <button *ngFor="let task of group.tasks; trackBy: trackTask" type="button" class="br-interactive task-row"
              (click)="openTask(task)" [attr.aria-label]="task.title + ', ' + statusLabels[task.status]">
        <span class="task-main"><span class="task-title">{{ task.title }}</span>
          <span class="task-subtitle">{{ task.agentName }} · {{ task.progress }}</span></span>
        <span class="task-status" [attr.data-status]="task.status">{{ statusLabels[task.status] }}</span>
        <br-icon aria-hidden="true">chevron_right</br-icon>
      </button>
    </ng-container>
  </ng-container>
</div>

<div class="tasks-scroll task-detail" *ngIf="selectedTask as task" aria-label="Task details">
  <h2>{{ task.title }}</h2>
  <div class="task-meta"><span>{{ task.agentName }}</span>
    <span class="task-status" [attr.data-status]="task.status">{{ statusLabels[task.status] }}</span></div>
  <p class="task-progress">{{ task.progress }}</p>
  <ng-container *ngIf="customDetail" [ngTemplateOutlet]="customDetail" [ngTemplateOutletContext]="{ $implicit: task }"></ng-container>
  <details class="task-agents" *ngIf="task.subAgents?.length" open>
    <summary>{{ task.subAgents?.length }} sub-agents working</summary>
    <ul><li *ngFor="let agent of task.subAgents"><span>{{ agent.name }}</span><span>{{ agent.activity }}</span></li></ul>
  </details>
  <p *ngIf="task.result" class="task-result">{{ task.result }}</p>
  <div *ngIf="task.error" class="br-alert br-alert--danger">{{ task.error }}</div>
  <div *ngIf="preview && task.status !== 'completed'" class="task-actions">
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
            (click)="taskAction.emit({ id: task.id, action: task.status === 'running' || task.status === 'queued' ? 'cancel' : 'retry' })">
      {{ task.status === 'running' || task.status === 'queued' ? 'Cancel task' : 'Retry task' }}
    </button>
  </div>
</div>
